import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M6235 7899 c-55 -13 -95 -54 -95 -95 0 -53 20 -64 113 -64 358 -2
608 -163 710 -459 26 -74 31 -106 36 -232 7 -156 14 -179 57 -179 95 0 140
116 114 298 -13 100 -58 242 -101 323 -69 128 -205 262 -334 325 -138 68 -393
110 -500 83z"
          />
          <path
            d="M6152 7570 c-65 -40 -63 -111 5 -129 21 -6 59 -11 84 -11 272 0 459
-190 459 -465 0 -116 22 -141 98 -114 61 21 79 128 46 287 -45 220 -203 387
-415 437 -96 22 -236 20 -277 -5z"
          />
          <path
            d="M2945 7478 c-3 -24 -5 -734 -3 -1578 4 -1695 -1 -1571 66 -1708 37
-79 159 -200 239 -241 131 -66 112 -64 932 -68 409 -2 748 0 752 4 5 5 -19 49
-53 100 -35 49 -83 131 -107 181 l-45 91 -625 3 c-577 3 -629 4 -666 21 -59
27 -82 54 -102 116 -16 52 -17 152 -18 1393 0 1084 2 1339 13 1350 11 11 213
13 1065 11 579 0 1094 -4 1145 -8 l92 -7 0 -669 0 -669 88 0 c48 0 131 3 185
7 l97 6 0 284 0 283 194 0 193 0 6 -67 c4 -38 7 -168 7 -290 l0 -223 118 -2
c156 -4 233 0 246 11 13 11 16 924 3 938 -5 4 -174 8 -375 8 -202 0 -373 4
-379 8 -10 6 -13 94 -13 383 l0 374 -1524 0 -1525 0 -6 -42z"
          />
          <path
            d="M6123 7281 c-36 -23 -50 -61 -37 -100 9 -24 17 -27 93 -39 130 -20
178 -51 211 -139 11 -30 20 -76 20 -103 0 -64 26 -95 73 -86 69 14 96 77 77
185 -21 128 -87 219 -198 273 -67 33 -194 37 -239 9z"
          />
          <path
            d="M6115 6961 c-63 -28 -96 -120 -56 -160 15 -15 34 -21 62 -21 33 0 47
6 75 34 29 29 34 41 34 79 0 26 -6 49 -14 56 -19 16 -76 23 -101 12z"
          />
          <path
            d="M3716 6753 c-18 -5 -18 -16 -11 -286 4 -155 8 -283 8 -284 7 -6 947
-6 1205 1 l322 9 0 278 c0 256 -1 278 -17 272 -9 -4 -14 -2 -11 3 6 10 -1462
17 -1496 7z m362 -10 c-38 -2 -98 -2 -135 0 -38 2 -7 3 67 3 74 0 105 -1 68
-3z"
          />
          <path
            d="M3723 5793 c-10 -3 -13 -51 -13 -187 l0 -183 122 -6 c154 -9 397 -9
808 0 l325 6 70 67 c38 36 98 85 131 108 34 22 64 48 68 57 3 9 6 43 6 74 l0
58 -412 6 c-470 8 -1087 8 -1105 0z"
          />
          <path
            d="M5960 5200 c0 -214 3 -390 6 -390 4 0 62 54 130 121 140 137 137 137
200 42 60 -90 86 -174 92 -293 5 -128 -7 -196 -54 -290 -67 -133 -180 -230
-327 -281 -161 -56 -302 -49 -447 23 -244 119 -369 394 -301 661 23 89 38 119
97 199 l44 60 -30 38 c-36 45 -218 220 -229 220 -35 0 -129 -128 -186 -254
-74 -163 -99 -310 -83 -497 33 -396 314 -734 694 -834 452 -119 917 97 1114
517 71 151 85 220 84 408 0 190 -16 266 -84 408 -39 82 -58 111 -138 210 -33
42 -40 57 -33 71 6 10 60 67 121 126 60 60 110 113 110 117 0 4 -175 8 -390 8
l-390 0 0 -390z"
          />
          <path
            d="M3706 5183 c-8 -49 -8 -257 0 -306 l7 -37 485 2 486 3 8 40 c15 71
80 259 99 284 42 53 62 51 -530 51 l-548 0 -7 -37z"
          />
          <path
            d="M3655 3530 c-116 -16 -193 -89 -211 -199 l-7 -41 91 0 90 0 19 38
c47 96 185 40 156 -63 -11 -37 -62 -65 -120 -65 l-43 0 0 -75 0 -75 28 0 c102
-1 152 -34 152 -102 0 -24 -6 -50 -13 -59 -29 -37 -84 -49 -131 -28 -23 11
-56 62 -56 88 0 7 -32 11 -91 11 l-92 0 6 -45 c17 -121 98 -195 232 -214 180
-26 313 56 323 200 2 32 1 74 -2 94 -8 42 -54 98 -96 115 -31 13 -40 30 -16
30 24 0 94 86 102 125 32 172 -115 293 -321 265z"
          />
          <path
            d="M2640 3095 l0 -395 95 0 95 0 2 241 3 240 159 -240 158 -241 94 0 94
0 0 395 0 396 -92 -3 -93 -3 -5 -240 -5 -239 -159 242 -158 242 -94 0 -94 0 0
-395z"
          />
          <path
            d="M4040 3410 l0 -80 105 0 105 0 0 -315 0 -315 95 0 95 0 0 315 0 315
100 0 100 0 0 80 0 80 -300 0 -300 0 0 -80z"
          />
          <path
            d="M4700 3095 l0 -395 173 0 c245 0 331 24 424 116 24 25 57 71 71 102
25 52 27 68 27 177 -1 143 -15 185 -95 269 -93 98 -195 125 -472 126 l-128 0
0 -395z m400 203 c26 -14 57 -41 75 -66 25 -36 30 -55 33 -117 9 -163 -61
-238 -232 -251 l-86 -7 0 232 0 231 83 0 c66 0 92 -5 127 -22z"
          />
          <path
            d="M5684 3454 c-14 -33 -123 -334 -230 -631 l-44 -123 100 0 99 0 22 70
23 70 150 -2 149 -3 22 -65 22 -65 100 -3 100 -3 -142 393 -142 393 -107 3
-107 3 -15 -37z m216 -461 c0 -2 -43 -3 -95 -3 -52 0 -95 4 -95 8 0 7 72 225
86 262 3 8 27 -46 55 -125 27 -77 49 -141 49 -142z"
          />
          <path
            d="M6210 3410 l0 -80 105 0 105 0 0 -315 0 -315 95 0 95 0 0 315 0 315
100 0 100 0 0 80 0 80 -300 0 -300 0 0 -80z"
          />
          <path
            d="M7084 3454 c-14 -33 -123 -334 -230 -631 l-44 -123 100 0 99 0 22 70
23 70 150 -2 149 -3 22 -65 22 -65 100 -3 100 -3 -142 393 -142 393 -107 3
-107 3 -15 -37z m216 -461 c0 -2 -43 -3 -95 -3 -52 0 -95 4 -95 8 0 7 72 225
86 262 3 8 27 -46 55 -125 27 -77 49 -141 49 -142z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
